import { z } from "zod";

const VariationMetafieldDtoSchema = z.object({
  variationId: z.string(),
  price: z.string().optional(),
  currencyCode: z.string().optional(),
});

export type VariationMetafieldDto = z.infer<typeof VariationMetafieldDtoSchema>;
